import React, { useState, useEffect } from 'react';
import TextInput from '../../layout/forms/TextInput';

const ObjectName = ({ state, setState }) => {
    const onChange = (event) => {
        setState({
            ...state,
            objectName: event.target.value
        })
    }
    return (
        <TextInput
            label="Object name"
            onChange={onChange}
            value={state.objectName}
        />
    )
}
export default ObjectName